import type { HrOffboardingReport, OnboardingReport } from '../resources'

type OnOffboardingReport = OnboardingReport | HrOffboardingReport

const sharedOnOffboardingColumnFormats = {
  createdDate: 'date_time',
  lastUpdatedDate: 'date_time',
}

export const getOnOffboardingColumnFormats = (type: 'onboarding' | 'offboarding') => ({
  ...(type === 'onboarding' ? { startDate: 'date' } : { endDate: 'date' }),
  ...sharedOnOffboardingColumnFormats,
})

export const getOnOffboardingExportRows = (
  reports: OnOffboardingReport[],
  type: 'onboarding' | 'offboarding'
) =>
  reports.map(report => ({
    employeeName: report.employeeName,
    contactNumber: report.contactNumber,
    contactEmail: report.contactEmail,
    employeeNumber: report.employeeNumber,
    company: report.company,
    department: report.department,
    ...(type === 'onboarding'
      ? { startDate: (report as OnboardingReport).startDate }
      : { endDate: (report as HrOffboardingReport).endDate }),
    createdDate: report.createdDate,
    createdBy: report.createdBy,
    lastUpdatedDate: report.lastUpdatedDate,
    lastUpdatedBy: report.lastUpdatedBy,
    status: report.status,
    reasonComment: report.reasonComment,
  }))
